//import { MVPDto, MVPDtoImpl } from './mvpdto';
//import { Base64 } from 'js-base64';

export interface PasswordValidationCCDto
{
    getMsisdn(): string;
    getChannel():string;
    getUsername():string;
    getPassword():string;
    getLanguage(): string;
    getSecurityCounter(): string;
}

export class PasswordValidationCCDtoImpl implements PasswordValidationCCDto
{
    private msisdn: string;
    private channel: string;
    private language: string;
    private securityCounter: string;
    private password: string;
    private username: string;

    getUsername(): string {
        return this.username;
    }
    getPassword(): string {
        return this.password;
    }

    setPassword(password: string)
    {
        this.password = password;
    }

    setUsername(username: string)
    {
        this.username = username;
    }

    getMsisdn(): string 
    {
        return this.msisdn;
    }
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }

    getChannel(): string 
    {
        return this.channel;
    }
    setchannel(passwordWithSecurityToken: string)
    {
        //console.log("PasswordWithSecurityToken B4 Base64 Encode:" + passwordWithSecurityToken);
        //this.channel = encodeURIComponent(passwordWithSecurityToken);
        //this.channel = Base64.encode(passwordWithSecurityToken);
        //console.log("PasswordWithSecurityToken Af Base64 Encode:" + this.channel);
        this.channel = passwordWithSecurityToken;
    }

    getLanguage(): string 
    {
        return this.language;
    }
    setLanguage(language: string)
    {
        this.language = language;
    }

    getSecurityCounter(): string 
    {
        return this.securityCounter;
    }
    setSecurityCounter(securityCounter: string) 
    {
        this.securityCounter = securityCounter;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/passwordvalidationcc/passwordvalidationccdto.tsx